import { type Resolution } from '@/features/jobs/Job'
import { type JobStatus } from '@/features/jobs/job-status'
import { getStatusDisplayText } from '@/features/jobs/job-status-display'
import { match } from '@/utils/pattern-match-util'

/**
 * Colour variant of the status cell.
 */
export type JobsTableStatusVariant =
  | 'onboarding'
  | 'infoGathering'
  | 'unclaimed'
  | 'claimed'
  | 'closed'
  | 'idle'
  | 'onHold'
  | 'pending'

/**
 * What the status cell shows for a job.
 */
export interface JobsTableStatus {
  text: string
  subtext?: string
  variant: JobsTableStatusVariant
}

/**
 * The status cell's text and variant for a job.
 */
export function formatJobsTableStatus(
  status: JobStatus,
  resolution: Resolution | null | undefined,
): JobsTableStatus {
  return {
    text: getStatusDisplayText(status),
    subtext:
      status === 'Closed'
        ? match(resolution ?? 'None', {
            Cancelled: 'cancelled',
            Test: 'test',
            Done: undefined,
            None: undefined,
          })
        : undefined,
    variant: match(status, {
      UnderConstruction: 'onboarding',
      InfoGathering: 'infoGathering',
      Unclaimed: 'unclaimed',
      Claimed: 'claimed',
      Closed: 'closed',
      Idle: 'idle',
      OnHold: 'onHold',
      Pending: 'pending',
    }),
  }
}
